import React from "react";
import {
  Typography,
  Button,
  Input,
  Avatar,
  IconButton,
} from "@material-tailwind/react";
import Swal from "sweetalert2"
import Toaster from "../../components/Toaster";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowDownTrayIcon, CheckBadgeIcon, ChevronDownIcon, EllipsisVerticalIcon, EyeIcon, FunnelIcon, MagnifyingGlassIcon, PencilSquareIcon, TrashIcon, XCircleIcon } from "@heroicons/react/24/solid";
import Select from 'react-select';
import { Popover } from 'react-tiny-popover';
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import ShowLoader from "@/components/Loader";
import { getMember, deleteMember, approveMember, setSelectedMember, fetchOffice } from "../../store/slices/memberSlice";
import { fetchOfficeCity, bulkActionUpdate } from "../../store/slices/internalUsersSlice";
import useHasPermission from "../../components/useHasPermission";
import ScrollToTop from "@/components/ScrollToTop";
import { useTranslation } from "react-i18next";


var action_options = [];

export function ListMember() {
  const { t } = useTranslation("member");
  const { t: ct } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [city, setCity] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);
  const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
  const [checkedAction, setCheckedAction] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);

  const { user } = useSelector((state) => state.user);
  const type = user?.roles ? user?.roles[0] : '';

  const page_url = type.replace(' ', '-')?.toLocaleLowerCase();
  const hasAddPermission = useHasPermission(`${page_url}.add`);
  const hasViewPermission = useHasPermission(`${page_url}.view`);
  const hasUpdatePermission = useHasPermission(`${page_url}.update`);
  const hasDeletePermission = useHasPermission(`${page_url}.delete`);

  const { offices_city } = useSelector((state) => state.internalUser);

  useEffect(() => {
    dispatch(fetchOffice(''));
    dispatch(fetchOfficeCity());

    action_options = [
      {
        label: ct('active'),
        value: 'active'
      },
      {
        label: ct('inactive'),
        value: 'inactive'
      },
      {
        label: t('list.approve'),
        value: 'approved'
      },
      {
        label: t('list.reject'),
        value: 'rejected'
      },
    ];

    action_options = action_options.filter(option => option.value !== 'deleted');
    if (hasDeletePermission) {
      action_options.push({
        label: t('list.delete'),
        value: 'deleted'
      });
    }
  }, [t, ct, hasDeletePermission]);

  useEffect(() => {
    dispatch(getMember({ type: type, page: currentPage, perPage: itemsPerPage, search: search, filter: filter, city: city }));
  }, [dispatch, currentPage, itemsPerPage, type, city]);

  const { list_users, offices, loading, list_loading } = useSelector((state) => state.member);

  const handelSearch = (event) => {
    const value = event.target.value;

    if (event.key === "Enter" && value) {
      dispatch(getMember({ type: type, page: 1, perPage: itemsPerPage, search: search, filter: filter, city: city }));
    } else if (event.key === "Backspace" && value.length === 0) {
      dispatch(getMember({ type: type, page: 1, perPage: itemsPerPage, search: '', filter: filter, city: city }));
    }
  }

  const handelRemoveSearch = () => {
    setSearch('');
    dispatch(getMember({ type: type, page: 1, perPage: itemsPerPage, search: '', filter: filter, city: city }));
  }

  const handleSearchClick = () => {
    dispatch(getMember({ type: type, page: 1, perPage: itemsPerPage, search: search, filter: filter, city: city }));
  }

  const handelFilter = (value) => {
    setFilter(value);
    dispatch(getMember({ type: type, page: 1, perPage: itemsPerPage, search: search, filter: value, city: city }));
  }

  const handelEdit = (id, mode = "edit") => {
    if (id) {
      const user = list_users?.users?.find((row) => String(row.id) === String(id));
      dispatch(setSelectedMember(user));
      navigate(`/dashboard/members/${mode}/${id}`);
    }
  }

  const handelCheckedItems = (action) => {
    setCheckedAction(action);
    setIsCheckedItemPopoverOpen(false);
    if (checkedItems.length) {
      Swal.fire({
        title: ct('areYouSure'),
        text: t('list.confirmAction'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: ct('yes')
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(bulkActionUpdate({ status: action, ids: checkedItems })).unwrap().then(() => {
            const pastTenseMap = {
              'active': 'activated',
              'inactive': 'inactivated',
              'approved': 'approved',
              'rejected': 'rejected',
              'deleted': 'deleted',
            };
            const pastTenseMsg = pastTenseMap[action] ?? action + "ed";
            Toaster.success(t('list.memberStatusSuccess', { status: pastTenseMsg }));
            setCheckedItems([]);
            setCheckedAction('');
            dispatch(getMember({ type: type, page: currentPage, perPage: itemsPerPage, search: search, filter: filter, city: city }));
          }).catch((error) => {
            Toaster.error(t('list.actionFailed'));
          });
        }
      });
    } else {
      Toaster.error(t('list.selectItemToAction'));
    }
  }

  const handleSingleCheck = (value) => {
    if (checkedItems.includes(value)) {
      setCheckedItems(checkedItems.filter((v) => v !== value));
    } else {
      setCheckedItems([...checkedItems, value]);
    }
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      const ids = list_users?.users?.map((row) => row.id) || [];
      setCheckedItems(ids);
    } else {
      setCheckedItems([]);
    }
  };

  const delete_row = (id) => {
    Swal.fire({
      title: ct('areYouSure'),
      text: ct('cannotUndo'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: ct('yesDelete')
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteMember(id)).unwrap().then(() => {
          Toaster.success(t('list.userDeletedSuccess'));
          dispatch(getMember({ type: type, page: currentPage, perPage: itemsPerPage, search: search, filter: filter, city: city }));
        }).catch((error) => {
          console.error("Delete failed:", error);
          Toaster.error(t('list.deleteFailed'));
        });
      }
    });
  }

  const [isPopoverOpen, setIsPopoverOpen] = useState([]);
  const openActionPopover = (id) => {
    const key = id;
    setIsPopoverOpen((prev) => {
      if (prev.includes(key)) {
        return [];
      } else {
        return [key];
      }
    });
  };

  const popoverRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(e) {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsPopoverOpen([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const approveRejectMember = async (id, value) => {
    var msg = value == 'approved' ? 'approve' : value == 'rejected' ? 'reject' : value;
    let actionVerbs = ["approve", "reject"];
    let text;
    if (actionVerbs.includes(msg.toLowerCase())) {
      text = t('list.confirmVerbAction', { action: msg, type: type.toLowerCase() });
    } else {
      text = t('list.confirmAdjectiveAction', { status: msg, type: type.toLowerCase() });
    }
    Swal.fire({
      title: ct('areYouSure'),
      text: `${text}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: ct('yes')
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(approveMember({ id, value })).unwrap().then((res) => {
          const pastTenseMap = {
            'active': 'activated',
            'inactive': 'inactivated',
            'approved': 'approved',
            'rejected': 'rejected',
          };
          const pastTenseMsg = pastTenseMap[res.status] ?? res.status + "ed";
          Toaster.success(t('list.typeStatusSuccess', { type: type, status: pastTenseMsg }));
          dispatch(getMember({ type: type, page: currentPage, perPage: itemsPerPage, search: search, filter: filter, city: city }));
        }).catch((error) => {
          console.error("Changes failed:", error);
          Toaster.error(t('list.changesFailed'));
        });
        setIsPopoverOpen([]);
      }
    });
  };


  const isAllChecked =
    list_users?.users?.length > 0 &&
    checkedItems.length === list_users.users.length;

  return (
    <div className="mt-5 mb-8 flex flex-col gap-8">
      {loading && <ShowLoader />}
      <ScrollToTop />
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 px-4 md:px-6">
        <div className="w-full md:flex-1">
          <Typography variant="h5" color="blue-gray">
            {t('list.memberListTitle')} ({list_users?.pagination?.total || 0})
          </Typography>
        </div>
        <div className="w-full md:flex-1 flex justify-center">
          <div className="w-full max-w-md relative">
            <Input className={search ? 'pr-10' : ''} label={t('list.searchPlaceholder')} icon={!search ? <MagnifyingGlassIcon className="h-5 w-5" /> : ''} value={search} onChange={(e) => setSearch(e.target.value)} onKeyUp={handelSearch} />
            {search && (
              <IconButton variant="text" size="sm" className="!absolute right-1 top-1" onClick={handelRemoveSearch}>
                <XCircleIcon className="h-5 w-5 text-red-500" />
              </IconButton>
            )}
          </div>
          {search && (<Button variant="outlined" className="flex items-center border-gray-300 capitalize font-bold bg-black text-white mx-2"
            onClick={handleSearchClick}
          ><MagnifyingGlassIcon className="w-4 h-4 mr-1" /> {t('list.searchPlaceholder')}</Button>)}
        </div>
        {hasAddPermission && <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 px-4 md:px-6">
          <Link to={`/dashboard/members/add`}>
            <Button variant="outlined" className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white"><PlusCircleIcon className="w-4 h-4" /> {t('list.addMemberButton')}</Button>
          </Link>
        </div>}
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 px-4 md:px-6">
        <div className="flex w-full md:w-auto items-center gap-3 flex-wrap justify-start md:justify-start">
          <Typography variant="h6" color="blue-gray">
            ({list_users?.pagination?.total ?? 0}) {(list_users?.pagination?.total === 1 || list_users?.pagination?.total === 0) ? t('list.item') : t('list.items')}
          </Typography>
          <Select
            placeholder={t('list.selectCityPlaceholder')}
            onChange={(city) => {
              if (city) {
                setCity(city.value);
              } else {
                setCity('');
              }
            }}
            options={offices_city}
            isClearable
          />
        </div>
        <div className="flex w-full md:w-auto items-center gap-3 flex-wrap justify-end md:justify-end">
          <Popover
            isOpen={isFilterPopoverOpen}
            positions={["bottom"]}
            padding={4}
            onClickOutside={() => setIsFilterPopoverOpen(false)}
            content={
              <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1 max-h-60 overflow-y-auto">
                <button
                  onClick={() => {
                    handelFilter("");
                    setIsFilterPopoverOpen(false);
                  }}
                  className={`text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 ${filter === '' ? 'bg-gray-100 font-semibold' : ''}`}
                >
                  {t('all')}
                </button>

                {offices?.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      handelFilter(option.value);
                      setIsFilterPopoverOpen(false);
                    }}
                    className={`text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 ${filter === option.value ? 'bg-gray-100 font-semibold' : ''}`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            }
          >
            <Button
              onClick={() => setIsFilterPopoverOpen(!isFilterPopoverOpen)}
              variant="outlined"
              className="flex items-center gap-2 border-gray-300 text-gray-800 capitalize font-medium"
            >
              <FunnelIcon className="h-4 w-4" /> {t('list.filter')} {filter && `(${filter})`}
            </Button>
          </Popover>
          {/* <Button
              variant="outlined"
              className="flex items-center gap-2 border-gray-300 text-gray-800 capitalize font-medium"
              onClick={() => {
                Toaster.success(t('list.comingSoon'));
              }}
            >
            <ArrowDownTrayIcon className="h-4 w-4" /> {t('list.download')}
          </Button> */}
          {hasUpdatePermission && <Popover
            isOpen={isCheckedItemPopoverOpen}
            positions={["bottom"]}
            padding={4}
            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
            content={
              <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                {action_options?.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => {
                      handelCheckedItems(option.value);
                    }}
                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            }
          >
            <Button
              onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
              variant="outlined"
              className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white"
            >
              {t('list.selectedItems')} {checkedAction && `(${checkedAction})`} <ChevronDownIcon className="h-4 w-4" />
            </Button>
          </Popover>}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px] table-auto text-left">
          <thead>
            <tr>
              {[t('list.memberId'), t('list.name'), t('list.contactNumber'), t('list.email'), t('list.location'), t('list.assigned'), t('list.status'), ''].map((el) => (
                <th
                  key={el}
                  className="border-b border-blue-gray-50 py-3 px-5 text-left"
                >
                  {el == t('list.memberId') ? (
                    <div className="flex items-center gap-4">
                      {hasUpdatePermission &&
                        <input
                          type="checkbox"
                          className="w-4 h-4 accent-green cursor-pointer"
                          onChange={(e) => handleCheckAll(e)}
                          checked={isAllChecked}
                        />
                      }
                      <Typography
                        variant="small"
                        className="text-[11px] font-bold text-black-gray"
                      >
                        {el}
                      </Typography>
                    </div>
                  ) : (
                    <Typography
                      variant="small"
                      className="text-[11px] font-bold text-black-gray"
                    >
                      {el}
                    </Typography>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list_loading ? <tr><td colSpan={8} className="text-center"> <div role="status">
              <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
            </div></td></tr> : ''}

            {list_users?.users?.length > 0 ? list_users?.users.map(
              ({ id, profile_image, first_name, mobile_number, country_code, email, office_name, status }, key) => {
                const className = `py-3 px-5 ${key === list_users.users.length - 1
                  ? ""
                  : "border-b border-blue-gray-50"
                  }`;

                return (
                  <tr key={id}>
                    <td className={className}>
                      <div className="flex items-center gap-4">
                        {hasUpdatePermission && <input type="checkbox"
                          className="w-4 h-4 accent-green cursor-pointer"
                          onChange={() => handleSingleCheck(id)}
                          checked={checkedItems.includes(id)}
                        />}
                        <Avatar src={profile_image ? profile_image : '/img/photo-gallery.png'} alt={first_name} size="sm" variant="rounded" />
                        <div>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-semibold"
                          >
                            {t('list.id', { id: String(id).padStart(4, "0") })}
                          </Typography>
                        </div>
                      </div>
                    </td>
                    <td className={className}>
                      <Typography className="text-xs font-semibold text-blue-gray-600">
                        {first_name}
                      </Typography>
                    </td>
                    <td className={className}>
                      {country_code} {mobile_number}
                    </td>
                    <td className={className}>
                      {email}
                    </td>
                    <td className={className}>
                      {office_name}
                    </td>
                    <td className={className}>
                      _
                    </td>
                    <td className={className}>
                      <span
                        className={`inline-flex items-center rounded-xl px-2 py-1 text-xs font-medium inset-ring inset-ring-green-600/20
                            ${status === 'pending'
                            ? 'bg-yellow-50 text-yellow-800'
                            : status === 'active'
                              ? 'bg-green-50 text-green-700'
                              : 'bg-red-50 text-red-700'
                          }`}
                      >
                        {status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : ""}

                      </span>

                    </td>
                    <td className={className}>
                      <div className="flex items-center space-x-2">
                        <Popover
                          isOpen={isPopoverOpen.includes(id)}
                          positions={['bottom', 'left']}
                          padding={4}
                          content={<div ref={popoverRef} className="bg-white shadow-xl rounded-md w-32 flex flex-col z-50 border border-gray-100 py-1">
                            {hasViewPermission &&
                              <button
                                className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                onClick={() => handelEdit(id, "view")}
                              >
                                <EyeIcon className="h-4 w-4 text-blue-500"></EyeIcon>
                                {t('list.view')}
                              </button>
                            }
                            {hasUpdatePermission &&
                              <button
                                className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                onClick={() => handelEdit(id, "edit")}
                              >
                                <PencilSquareIcon className="h-4 w-4 text-blue-500"></PencilSquareIcon>
                                {t('list.edit')}
                              </button>
                            }
                            {hasDeletePermission &&
                              <button
                                className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                onClick={() => delete_row(id)}
                              >
                                <TrashIcon className="h-4 w-4 text-red-500"></TrashIcon>
                                {t('list.delete')}
                              </button>
                            }
                            {hasUpdatePermission && <>
                              {status === "pending" &&
                                <>
                                  <button
                                    className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                    onClick={() => approveRejectMember(id, "approved")}
                                  >
                                    <CheckBadgeIcon className="h-4 w-4 text-blue-500" />
                                    {t('list.approve')}
                                  </button>
                                  <button
                                    className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                    onClick={() => approveRejectMember(id, "rejected")}
                                  >
                                    <XCircleIcon className="h-4 w-4 text-red-500" />
                                    {t('list.reject')}
                                  </button>
                                </>
                              }
                              {status === "rejected" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => approveRejectMember(id, "approved")}
                                >
                                  <CheckBadgeIcon className="h-4 w-4 text-blue-500" />
                                  {t('list.approve')}
                                </button>
                              }
                              {status === "active" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => approveRejectMember(id, "inactive")}
                                >
                                  <XCircleIcon className="h-4 w-4 text-red-500" />
                                  {t('list.inactivate')}
                                </button>
                              }
                              {status === "inactive" &&
                                <button
                                  className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                  onClick={() => approveRejectMember(id, "active")}
                                >
                                  <CheckBadgeIcon className="h-4 w-4 text-blue-500" />
                                  {t('list.activate')}
                                </button>
                              }</>}
                          </div>}>
                          <IconButton variant="text" color="blue-gray" onClick={() => openActionPopover(id)}>
                            <EllipsisVerticalIcon className="h-6 w-6" />
                          </IconButton>
                        </Popover>
                      </div>
                    </td>
                  </tr>
                );
              }
            ) : (
              !list_loading && (
                <tr>
                  <td colSpan={8} className="text-center py-3">
                    {t('list.noData')}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
      {list_users?.pagination && (
        <Pagination currentPage={currentPage} itemsPerPage={itemsPerPage} setCurrentPage={setCurrentPage} setItemsPerPage={setItemsPerPage} totalPages={list_users?.pagination?.last_page} />
      )}
    </div>
  );
}

export default ListMember;